import Slider from "react-slick";
import { useEffect, useRef } from "react";

import './testimonial_section_style.scss';

const CustomPrevArrow = ({currentSlide, slideCount, ...props}) => {
    return (
        <span {...props} className="slick-arrow arrow-prev">
            <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.77778 2L2 10M2 10L9.77778 18M2 10H22" stroke="#638959" strokeWidth="2" strokeLinecap="square"/>
            </svg>
        </span>
    );
};
  
const CustomNextArrow = ({currentSlide, slideCount, ...props}) => {
    return (
        <span {...props} className="slick-arrow arrow-next">
            <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.2222 2L21 10M21 10L13.2222 18M21 10H1" stroke="#638959" strokeWidth="2" strokeLinecap="square"/>
            </svg>
        </span>    
    );
};

const testimonialsSettings = {
    centerMode: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerPadding: 30,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: true,
    arrows: true,
    //autoplay: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
        },
    ]
}

export const TestimonialSection = ({
    fields
}) => {
    const sliderRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            if (sliderRef.current) {
                const slides = sliderRef.current.querySelectorAll('.slick-slide');
                let maxHeight = 0;
    
                slides.forEach(slide => {
                    const slideHeight = slide.clientHeight;
                    if (slideHeight > maxHeight) {
                        maxHeight = slideHeight;
                    }
                });
                
                slides.forEach(slide => {
                    slide.querySelectorAll(".block-item .item-content")[0].style.height = `${maxHeight}px`;
                });
            }
        }, 500);
    }, []);

    return <section id="testi-section" className="home-section">
        <div className="container">
            <div className='inner-wrapper'>
                <div className='section-header'>
                    <span className='main-category'>{ fields?.testimonials_pre_title ?? 'Testimonials' }</span>
                    <h2>
                        <span className='title-first'>Hear it From</span>
                        <span className='title-second'>Our Clients</span>
                    </h2>
                </div>

                <div ref={sliderRef} className='testi-wrapper'>
                    {
                        fields?.testimonial_repeater && <Slider {...testimonialsSettings} className="testi-repeater" >
                            {
                                fields?.testimonial_repeater?.map((it, index) => <div className='block-item' key={index}>
                                    <div className='decoration'></div>
                                    <div className='item-content'>
                                        <p dangerouslySetInnerHTML={{__html: it?.block_description}}></p>
                                        <div className='block-meta'>
                                            <span className='name'>{it?.block_user}</span>
                                        </div>
                                    </div>
                                </div>)
                            }                        
                        </Slider>
                    }
                </div>
            </div>
       </div>
    </section>
}